import React, {Component} from 'react'

import {AppWrapper, FunnelPage} from '@influxdata/clockface'
import {HoneybadgerErrorBoundary} from '@honeybadger-io/react'

import HBContext from 'js/honeyBadgerContext.js'
import LogoWithCubo from 'js/components/LogoWithCubo'

import {SignUpPageContents, SignUpMode} from './SignUpPageContents'
import FunnelSubHeader from '../shared/FunnelSubheader'
import FunnelHeader from '../shared/FunnelHeader'

interface Props {
  mode?: SignUpMode
  email?: string
}

class SignUp extends Component<Props> {
  static contextType = HBContext
  render() {
    const {email = '', mode = 'signup'} = this.props
    return (
      <HoneybadgerErrorBoundary honeybadger={this.context}>
        <AppWrapper>
          <FunnelPage enableGraphic={true} logo={<LogoWithCubo />}>
            <FunnelHeader text="Create your Free InfluxDB Cloud Serverless Account" />
            <FunnelSubHeader text="No credit card required" />
            <SignUpPageContents email={email} mode={mode} />
          </FunnelPage>
        </AppWrapper>
      </HoneybadgerErrorBoundary>
    )
  }
}

export default SignUp
